export class SelfReportsModel {
    keyword = '';
    country_id = 0;
    can_remove = null;
    domains = [];
    id = null;
    is_default = null;
    name = null;
    type = 1;
}